<template>
  <div class="calc-params">
    <h3 class="calc-params__title">Калькулятор с искусственным интеллектом</h3>
    <h3 class="calc-params__title calc-params__title--mobile">
      Калькулятор с ИИ
    </h3>
    <button class="calc-params__reset">Сбросить</button>

    <form class="calc-params__form form" action="#">
      <div class="form__select">
        <CalcSelect
          label="Цель"
          name="target"
          id="target-select"
          @input="$emit('input', $event)"
          :options="options"
        />
      </div>
      <div class="form__select select">
        <span>Регион приобретения продукта</span>
        <svg
          class="select__icon"
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M18.53 9.53a.75.75 0 0 0 0-1.06H5.47a.75.75 0 0 0 0 1.06l6 6a.75.75 0 0 0 1.06 0z"
          />
        </svg>
      </div>
      <div class="form__select">
        <span>Стоимость объекта</span>
      </div>
      <div class="form__select">
        <span class="form__percent-text">Первоначальный взнос</span>
        <div class="form__percent-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="currentColor"
          >
            <path
              d="M7.5 11C9.43 11 11 9.43 11 7.5S9.43 4 7.5 4 4 5.57 4 7.5 5.57 11 7.5 11m0-5C8.33 6 9 6.67 9 7.5S8.33 9 7.5 9 6 8.33 6 7.5 6.67 6 7.5 6M4.0025 18.5832 18.59 3.9955l1.4142 1.4143L5.4167 19.9974zM16.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5m0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5"
            ></path>
          </svg>
        </div>
      </div>
    </form>
    <div v-show="loading" class="calc-params--loading"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { OptionsFormParam } from '@/types/Widget'
import CalcSelect from './calc-select.vue'

export default defineComponent({
  name: 'CalcParams',
  components: {
    CalcSelect,
  },
  props: {
    options: {
      type: Array as () => OptionsFormParam[],
      default: null,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['input'],
})
</script>

<style lang="scss" scoped>
.calc-params {
  padding: 20px 28px;
  position: relative;

  &--loading {
    z-index: 100;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
  }

  &__title {
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    text-transform: uppercase;
    color: #434242;

    &--mobile {
      display: none;
    }
  }

  &__reset {
    position: absolute;
    top: 20px;
    right: 28px;
    cursor: pointer;
    text-decoration: underline;
    display: block;
    margin-left: auto;
    border: none;
    background: none;
    font-size: 16px;
    color: #686868;
    margin-bottom: 10px;
  }

  &__info {
    margin-top: 20px;
  }
}

.form {
  padding: 5px 0 8px;
  position: relative;
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  &__select {
    position: relative;
    width: 100%;
    height: 48px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    color: #9e9e9e;

    span {
      position: absolute;
      left: 24px;
      right: 26px;
      color: #9e9e9e;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &::before,
    &::after {
      border-color: rgba(0, 0, 0, 0.2);
      color: rgba(0, 0, 0, 0.2);
    }

    &:first-child {
      border-color: #960000;

      &::before,
      &::after {
        border-color: #960000;
      }
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      right: -7px;
      top: -1px;
      width: 10px;
      height: 24px;
      z-index: 2;
      transform: skewX(30deg);
      border-right: 1px solid;
      border-color: inherit;
    }

    &::after {
      top: 23px;
      transform: skewX(-30deg);
    }
  }

  &__percent-text {
    right: 90px !important;
  }

  &__percent-icon {
    position: absolute;
    right: 20px;
    height: 26px;
    width: 70px;
    border-radius: 13px;
    padding: 0 8px;
    border: 1px solid rgba(0, 0, 0, 0.2);

    display: flex;
    align-items: center;
    justify-content: end;

    svg {
      width: 18px;
    }
  }

  label {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 12px;
    font-weight: 500;
    color: #960000;
    background-color: #fff;
    padding: 0 8px;
    transition: all 0.2s;
  }
}

.select {
  &__icon {
    position: absolute;
    right: 8px;
    width: 18px;
    color: #9e9e9e;
  }
}

.info {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__links {
    a {
      color: #686868;
    }
  }

  &__count {
    display: flex;
    gap: 6px;

    img {
      height: 19px;
    }

    span {
      font-size: 18px;
      color: #0097ce;
    }
  }
}

@media (min-width: 960px) {
  .form {
    &__select {
      &:not(:last-child) {
        border-right: none;
      }

      &:not(:first-child) {
        border-left: none;
      }

      &:first-child {
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-left: 1px solid inherit;
      }

      &:last-child {
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        border-right: 1px solid inherit;

        &::before,
        &::after {
          display: none;
        }
      }
    }
  }
}

@media (min-width: 601px) and (max-width: 959px) {
  .calc-params {
    &__reset {
      position: static;
    }
  }

  .form {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 28px;

    svg {
      right: 18px;
    }

    &__select {
      &:nth-child(2n) {
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        border-right: 1px solid inherit;
        border-left: none;

        &::before,
        &::after {
          display: none;
        }
      }

      &:nth-child(2n + 1) {
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-left: 1px solid inherit;
        border-right: none;
      }
    }
  }

  .select {
    &__icon {
      right: 18px;
    }
  }
}

@media (max-width: 600px) {
  .calc-params {
    padding: 20px 15px;

    &__title {
      display: none;

      &--mobile {
        display: block;
      }
    }

    &__reset {
      position: static;
    }
  }

  .select {
    &__icon {
      right: 28px !important;
    }
  }

  .form {
    grid-template-columns: 1fr;
    row-gap: 12px;
    padding-right: 30px;
    padding-top: 20px;

    &__select {
      border: 1px solid inherit;
      border-radius: 0px;
      padding-right: 20px;

      &:first-child {
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;
      }

      &:last-child {
        border-bottom-right-radius: 20px;
        border-bottom-left-radius: 20px;
      }

      &::before,
      &::after {
        display: none;
      }
    }
  }

  .info {
    flex-direction: column;
    gap: 10px;

    &__links {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
